import React, { useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Logo from "../components/Logo";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}


const EyeOpen = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7
         -1.274 4.057-5.064 7-9.542 7
         -4.477 0-8.268-2.943-9.542-7z" />
  </svg>
);

const EyeClosed = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M13.875 18.825A10.05 10.05 0 0112 19
         c-4.478 0-8.268-2.943-9.542-7
         a9.956 9.956 0 012.041-3.368M6.223 6.223
         A9.956 9.956 0 0112 5c4.478 0 8.268 2.943 9.542 7
         a9.978 9.978 0 01-4.132 5.411M15 12a3 3 0 00-3-3" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
      d="M3 3l18 18" />
  </svg>
);

const ResetPasswordPage = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { confirmPasswordReset } = useAuth();

  const token = query.get("token") || "";
  const email = query.get("email") || "";

  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
const [showConfirmPassword, setShowConfirmPassword] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!token || !email) {
      setError("Link inválido. Volvé a solicitar el cambio de contraseña.");
      return;
    }

    if (newPassword.length < 8) {
      setError("La contraseña debe tener al menos 8 caracteres.");
      return;
    }

    if (newPassword !== confirm) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    try {
      setLoading(true);
      await confirmPasswordReset({ email, token, newPassword });
      setSuccess(true);

      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setError(err?.message || "No se pudo restablecer la contraseña.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-accent-50 via-white to-primary-50 flex flex-col">
      <header className="bg-white shadow-sm border-b border-neutral-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Logo className="h-12 sm:h-14" />
        </div>
      </header>

      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
        <div className="max-w-md w-full">
          <div className="bg-white rounded-2xl shadow-xl p-8 animate-scale-in">
            {!success ? (
              <>
                <div className="text-center mb-8">
                  <div className="text-5xl mb-4">🔑</div>
                  <h2 className="text-3xl font-display font-bold text-neutral-900 mb-2">
                    Crear nueva contraseña
                  </h2>
                  <p className="text-neutral-600">
                    Ingresá tu nueva contraseña para <strong>{email || "tu cuenta"}</strong>.
                  </p>
                </div>

                {error && (
                  <div className="mb-6 bg-red-50 border border-red-200 text-red-700 rounded-lg p-4 text-sm">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-2">
                      Nueva contraseña
                    </label>

                   <div className="relative">
  <input
    type={showNewPassword ? "text" : "password"}
    value={newPassword}
    onChange={(e) => setNewPassword(e.target.value)}
    required
    minLength={8}
    className="input-field pr-12"
    placeholder="••••••••"
  />

   <button
    type="button"
    onClick={() => setShowNewPassword(!showNewPassword)}
    className="absolute inset-y-0 right-0 flex items-center px-3 text-neutral-500 hover:text-neutral-700"
    aria-label={showNewPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
  >
    {showNewPassword ? <EyeOpen /> : <EyeClosed />}
  </button>
</div>
                    <p className="text-xs text-neutral-500 mt-1">Mínimo 8 caracteres</p>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-neutral-700 mb-2">
                      Confirmar contraseña
                    </label>
                 <div className="relative">
  <input
    type={showConfirmPassword ? "text" : "password"}
    value={confirm}
    onChange={(e) => setConfirm(e.target.value)}
    required
    minLength={8}
    className="input-field pr-12"
    placeholder="••••••••"
  />

  <button
    type="button"
    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
    className="absolute inset-y-0 right-0 flex items-center px-3 text-neutral-500 hover:text-neutral-700"
    aria-label={showConfirmPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
  >
    {showConfirmPassword ? <EyeOpen /> : <EyeClosed />}
  </button>
</div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full btn-primary text-lg"
                  >
                    {loading ? "Guardando..." : "Restablecer contraseña"}
                  </button>
                </form>

                <div className="mt-6 text-center">
                  <Link
                    to="/forgot-password"
                    className="text-accent-600 hover:text-accent-700 text-sm font-medium"
                  >
                    ← Volver a solicitar link
                  </Link>
                </div>
              </>
            ) : (
              <div className="text-center">
                <div className="text-6xl mb-4">✅</div>
                <h2 className="text-3xl font-display font-bold text-neutral-900 mb-4">
                  Contraseña actualizada
                </h2>
                <p className="text-neutral-600 mb-6">
                  Ya podés iniciar sesión con tu nueva contraseña.
                </p>
                <Link to="/login" className="btn-primary inline-block">
                  Ir a Login
                </Link>
              </div>
            )}
          </div>

          <div className="mt-6 text-center">
            <Link to="/" className="text-neutral-600 hover:text-neutral-900 text-sm font-medium">
              ← Volver al inicio
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ResetPasswordPage;
